export const SET_DATA = 'SET_DATA';
export const SHOW_LOADING = 'SHOW_LOADING';
export const DELETE_MY_ENQUIRY_SUCCESS = 'DELETE_MY_ENQUIRY_SUCCESS';
export const DELETE_MY_ENQUIRY_FAIL = 'DELETE_MY_ENQUIRY_FAIL';
